jQuery( document ).ready(function($) {
    if($('#iframe').length > 0) {
        $('#iframe').ready(function(){
            resizeIframe($('#iframe'));
        });
    }

    function resizeIframe(obj) {
        obj[0].style.height = obj[0].contentWindow.window.top.document.body.scrollHeight + 'px';
    }

    if($('#iframe').length > 0) {
        $('.instagram').remove();
    }

});